import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { NorthEast } from '@mui/icons-material';
import { navigateButtonStyles } from './NavigateButton.styles';

const NavigateButton = ({ title, isSecondary = false, onClick }) => {
  const styles = navigateButtonStyles(isSecondary);

  return (
    <Button
      variant="contained"
      disableElevation
      sx={styles.button}
      onClick={onClick}
      endIcon={
        <Box sx={styles.iconBox}>
          <NorthEast sx={styles.icon} />
        </Box>
      }
    >
      <Typography sx={styles.textStyle}>
      {title}
      </Typography>
     
    </Button>
  );
};

export default NavigateButton;
